import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { LanguageService } from '@shared/partner-ui/services/language.service';
import { AuthService } from '../services/auth.service';
import { FeatureFlagsService } from '../services/feature-flags.service';

const redirectToStory = (router: Router, language: LanguageService) =>
  router.createUrlTree(['/', language.currentLanguage, 'story']);

export const experiencesPlatformFeatureGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const language = inject(LanguageService);
  const featureFlags = inject(FeatureFlagsService);

  const flags = await featureFlags.loadFlags().catch(() => featureFlags.snapshot());

  return flags.showExperiences ? true : redirectToStory(router, language);
};

export const experiencesFeatureGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const language = inject(LanguageService);
  const auth = inject(AuthService);
  const featureFlags = inject(FeatureFlagsService);

  const flags = await featureFlags.loadFlags().catch(() => featureFlags.snapshot());
  if (!flags.showExperiences) {
    return redirectToStory(router, language);
  }

  await auth.ensureInitialized();
  const account = auth.user();

  return account?.experiencesEnabled ? true : redirectToStory(router, language);
};
